module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-stone-path-background-remnants.a02dcd39.png";